import { useTranslation } from 'react-i18next'
import { NetworkSelect } from './DepositInfo.network'
import { DepositAddress } from './DepositInfo.address'
import { DepositViewComponentDepositAddressQuery$data } from '@src/components/wallet/__generated__/DepositViewComponentDepositAddressQuery.graphql'
import { Wrapper } from './DepositInfo.styled'

interface DepositInfoProps {
  isExternalCurrency: boolean
  selectedExternalCoin?: { coin?: string; token?: string; chain: string }
  coin?: any // Replace with proper type
  depositAddressData?: DepositViewComponentDepositAddressQuery$data | undefined
  paymentOrder?: { address: string; memo: string | null }
  onNetworkSelect: (tokenId: string, chain: string) => void
}

export const DepositInfo = ({
  isExternalCurrency,
  selectedExternalCoin,
  coin,
  depositAddressData,
  paymentOrder,
  onNetworkSelect,
}: DepositInfoProps) => {
  const { t } = useTranslation()

  return (
    <Wrapper>
      {isExternalCurrency && (
        <NetworkSelect selectedExternalCoin={selectedExternalCoin} coin={coin} onSelect={onNetworkSelect} />
      )}
      {depositAddressData && (
        <DepositAddress
          address={depositAddressData.lastDepositAddress!.address}
          depositAddressData={depositAddressData}
        />
      )}
    </Wrapper>
  )
}
